import { PageInicio } from "./Pages/Inicio"
import { PageConsultaVagas } from "./Pages/ConsultaVagas"
import { GerenciarVagas } from "./Pages/GerenciarVagas"

export function PagesRoles(role) {
    let pages = []
    if (role === "User") {
        pages = [
            PageInicio,
            PageConsultaVagas,
        ]
    } else if (role === "Company") {
        pages = [
            PageInicio,
            GerenciarVagas,
        ]
    }

    return pages
}